import { Component, Input, OnInit } from '@angular/core';
import { TripMetadata } from '../_models/driver-data';

@Component({
  standalone: false,
  selector: 'app-driver-description',
  templateUrl: './driver-description.component.html',
  styleUrls: ['./driver-description.component.scss']
})
export class DriverDescriptionComponent implements OnInit {

  constructor() { }
  
  @Input() postSign: boolean = false;
  @Input() driverSignerData: TripMetadata;

  ngOnInit(): void {
  }

}
